import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    MdArrowBack, MdMeetingRoom, MdShield, MdSpeed, MdSupport, MdCalendarToday, MdAttachMoney
} from 'react-icons/md';
import { LanguageSelector, useLanguage } from '../i18n';
import { API_BASE, withSystem, SYSTEM_SLUG } from './publicApi';

// Moved off the homepage (PublicBooking.js) so the homepage itself stays a
// short, two-screen scroll. This page carries the same "Our Services"
// content that used to live in a <section id="services"> there — now its
// own route so it doesn't add to the homepage's length, but is still one
// click away from the nav bar / footer.
export default function ServicesPage() {
    const { t } = useLanguage();
    const [homepage, setHomepage] = useState(null);

    // The built-in services wording belongs to the platform, not to an organization.
    if (SYSTEM_SLUG) { window.location.replace(`/?system=${encodeURIComponent(SYSTEM_SLUG)}`); }

    useEffect(() => {
        axios.get(`${API_BASE}/homepage`, { params: withSystem() }).then(response => {
            setHomepage(response.data);
        }).catch(() => { });
    }, []);

    const currency = homepage?.currency || 'RWF';

    return (
        <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Inter',-apple-system,sans-serif" }}>
            <nav style={{
                background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 5%', height: 68,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'sticky', top: 0, zIndex: 200, boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <img src={homepage?.logo_url || '/logo512.png'} alt={`${homepage?.system_name || 'MITI FMS'} ${t('services.logoAlt')}`} style={{ width: 38, height: 38, borderRadius: 9, objectFit: 'cover' }} />
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', lineHeight: 1 }}>{homepage?.system_name || 'MITI FMS'}</div>
                        <div style={{ fontSize: 10, color: '#94a3b8', letterSpacing: '0.5px' }}>{t('services.facilityManagementLabel')}</div>
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <LanguageSelector style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 8px' }} />
                    <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#2563eb', fontWeight: 600, textDecoration: 'none', border: '1.5px solid #2563eb', padding: '7px 16px', borderRadius: 8 }}>
                        <MdArrowBack size={15} /> {t('services.backToHome')}
                    </a>
                </div>
            </nav>

            <section style={{ padding: '64px 5% 80px', background: 'linear-gradient(180deg,#f0f9ff,#fff)' }}>
                <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: 56 }}>
                        <span style={{ fontSize: 12, fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '1.5px' }}>{t('services.eyebrow')}</span>
                        <h1 style={{ fontWeight: 800, fontSize: 36, color: '#0f172a', marginTop: 8, marginBottom: 16 }}>{t('services.heroTitle')}</h1>
                        <p style={{ color: '#64748b', maxWidth: 520, margin: '0 auto', fontSize: 16 }}>
                            {t('services.heroSubtitle')}
                        </p>
                    </div>

                    <div className="row g-4">
                        {[
                            { icon: <MdMeetingRoom size={28} style={{ color: '#2563eb' }} />, title: t('services.spaceBookingTitle'), desc: t('services.spaceBookingDesc') },
                            { icon: <MdShield size={28} style={{ color: '#22c55e' }} />, title: t('services.assetManagementTitle'), desc: t('services.assetManagementDesc') },
                            { icon: <MdSpeed size={28} style={{ color: '#f59e0b' }} />, title: t('services.maintenanceTitle'), desc: t('services.maintenanceDesc') },
                            { icon: <MdSupport size={28} style={{ color: '#8b5cf6' }} />, title: t('services.workOrdersTitle'), desc: t('services.workOrdersDesc') },
                            { icon: <MdCalendarToday size={28} style={{ color: '#ef4444' }} />, title: t('services.bookingManagementTitle'), desc: t('services.bookingManagementDesc') },
                            { icon: <MdAttachMoney size={28} style={{ color: '#0d9488' }} />, title: t('services.paymentsTitle', '', {currency}), desc: t('services.paymentsDesc', '', {currency}) },
                        ].map(s => (
                            <div key={s.title} className="col-lg-4 col-md-6">
                                <div style={{ background: '#fff', borderRadius: 14, padding: 28, border: '1px solid #e2e8f0', height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                    <div style={{ width: 54, height: 54, borderRadius: 12, background: '#f0f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                                        {s.icon}
                                    </div>
                                    <h5 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 10 }}>{s.title}</h5>
                                    <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, margin: 0 }}>{s.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <footer style={{ background: '#0f172a', color: '#94a3b8', padding: '24px 5%', textAlign: 'center', fontSize: 13 }}>
                © {new Date().getFullYear()} {homepage?.system_name || 'MITI FMS'}. {t('services.footerRights')}
            </footer>
        </div>
    );
}
